// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Franchise } from '@/lib/types/api/franchise-data';
import { ShowRowContent, ShowOrFranchiseEnum } from '@/lib/types/api/show-data';

// components
import ContentRowTitleDescription from '@/components/ContentRowTitleDescription/ContentRowTitleDescription';
import LinkButton from '@/components/Button/LinkButton';
import ShowPoster, { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';
import ShowGridCard from '@/components/ShowGrid/ShowGridCard';

// styles
import styles from './ShowGrid.module.scss';

export interface ShowGridProps {
  description?: string;
  enableShowGridCards?: boolean;
  franchiseContext?: boolean;
  includeWrapper?: boolean;
  limit?: number;
  link?: {
    href: string;
    text: string;
  }
  onShowPosterClick?: (show: ShowRowContent, index?: number, linkHref?: string) => void;
  shows: ShowRowContent[]
  title?: string;
  showBadgeFlags?: ShowBadgeFlags
}

export default function ShowGrid(props: ShowGridProps) {
  const {
    description,
    enableShowGridCards = false,
    franchiseContext = false,
    includeWrapper,
    limit,
    link,
    onShowPosterClick,
    showBadgeFlags,
    title,
  } = props;

  let { shows } = props;

  // Right now the django app sends us some lists of shows, with the first one being a franchise.
  // But that franchise show doesn't have an item_type.
  // if we're displaying a grid that has to do with a franchise,
  if (franchiseContext && shows?.length > 0) {
    const firstShow = shows[0] as Franchise;
    const hasShowPoster = firstShow.images?.['franchise-poster2x3'] || firstShow.image?.includes('franchise-poster2x3')
    // if the first show in the list lacks an item_type AND has a franchise poster
    if (firstShow.item_type === undefined && hasShowPoster) {
      // we're going to move the franchise show from 1st to 3rd in the array
      // so that it shows up as the first poster after the show grid cards
      const franchiseShow = shows.splice(0,1)[0];
      shows.splice(2,0,{
        ...franchiseShow,
        item_type: ShowOrFranchiseEnum.Franchise
      });
    }
  }

  // apply any limits if one exists
  if (limit) {
    shows = shows.slice(0, limit);
  }

  let firstShow: ShowRowContent | undefined;
  let secondShow: ShowRowContent | undefined;

  // grab the first two shows to display as ShowGridCards if enabled
  if (enableShowGridCards) {
    firstShow = shows.splice(0,1)[0];
    secondShow = shows.splice(0,1)[0];
  }

  const showGridShowPosterSizes = `
    (min-width: 1700px) 227px,
    (min-width: 875px) calc((100vw - 124px) / 6),
    (min-width: 600px) calc((100vw - 112px) / 4),
    calc((100vw - 48px) / 3)
  `;

  return (
    <div className={includeWrapper ? styles.show_grid_wrapper : undefined} data-sentry-component="ShowGrid" data-sentry-source-file="ShowGrid.tsx">
      { title && (
        <ContentRowTitleDescription
          title={title}
          description={description}
        />
      )}
      <ul className={styles.show_grid}>
        { enableShowGridCards && firstShow && secondShow && (
          <>
            <li key={`${firstShow.slug}-first-poster`} className={styles.show_grid__poster}>
              <ShowPoster show={firstShow} index={0} onClick={onShowPosterClick} sizes={showGridShowPosterSizes} showBadgeFlags={showBadgeFlags} className={styles.show_grid__show_poster}/>
            </li>
            <li key={`${firstShow.slug}-first-card`} className={styles.show_grid__card} >
              <ShowGridCard show={firstShow} />
            </li>
            <li key={`${secondShow.slug}-second-poster`} className={styles.show_grid__poster}>
              <ShowPoster show={secondShow} index={1} onClick={onShowPosterClick} sizes={showGridShowPosterSizes} showBadgeFlags={showBadgeFlags} className={styles.show_grid__show_poster}/>
            </li>
            <li key={`${secondShow.slug}-second-card`} className={styles.show_grid__card}>
              <ShowGridCard show={secondShow} />
            </li>
          </>
        )}
        {shows && shows.map((show, index)=>{
          // Calculate the index accounting for the two shows that were spliced out for ShowGridCards
          const showIndex = enableShowGridCards && firstShow && secondShow ? index + 2 : index;
          return (
            <li key={show.slug} className={styles.show_grid__poster}>
              <ShowPoster
                show={show}
                index={showIndex}
                onClick={onShowPosterClick}
                sizes={showGridShowPosterSizes}
                showBadgeFlags={showBadgeFlags}
                className={styles.show_grid__show_poster}
              />
            </li>
          )
        })}
      </ul>
      {link && (
        <LinkButton href={link.href} className={styles.show_grid_link_button}>
          {link.text}
        </LinkButton>
      )}
    </div>
  )
}
